import axios from "axios";
import { Invitation } from "../types/ClientOnboardInvitation";
import { ListTitlesType } from "../types/role";
import { baseUrl, HttpMethods } from "./base";
import { GetCurrentAccountInfoResponse } from "../types/Account";
import { ClientListInterface } from "../pages/SageAdmin/Clients/types";
import { ClientDetailsInterface } from "../pages/SageAdmin/Clients/Details/types";

export async function sendInvite(formData: Invitation) {
  const res = await axios.post("/sherpa/v0/api/accounts/onboard", formData);
  return res.data;
}

export async function getAccountInfo() {
  const res = await axios.get<GetCurrentAccountInfoResponse>(
    `${baseUrl.SHERPA}/accounts/info`
  );
  return res.data;
}

export async function getClientAccountDetails(accountId: number) {
  const resp = await axios(`${baseUrl.SHERPA}/accounts/${accountId}`);
  return resp.data;
}

export async function updateClientAccountStatus(
  accountId: number,
  status: string
) {
  const res = await axios.patch(`/sherpa/v0/api/accounts/${accountId}`, {
    status,
  });
  return res.data;
}

export async function changeClientAccountLogo(
  accountId: number,
  data: { logoImage: any }
) {
  const res = await axios.patch(
    `${baseUrl.SHERPA}/accounts/${accountId}`,
    data
  );
}

export async function getAccountSubdomain(subdomain: string) {
  const res = await axios.post("/sherpa/v0/api/accounts/is_available", {
    subdomain,
  });
  return res.data as {
    data: {
      available: boolean;
    };
  };
}

interface GetClientAccountsService {
  params: IGetTenantsParams;
}

export interface IGetTenantsParams {
  perPage: number;
  page: number;
  status?: "ACTIVE" | "SUSPENDED" | "INVITED";
  subdomain?: string;
}

export interface GetAccountListResponse {
  data: ClientListInterface[];
  meta: { total: number };
}

export async function getAccountList({
  params,
}: Partial<GetClientAccountsService>) {
  const res = await axios.request<GetAccountListResponse>({
    method: HttpMethods.GET,
    url: `/sherpa/v0/api/accounts/list`,
    params,
  });
  return res.data;
}

export async function fetchAccountTitles() {
  const res = await axios.get<{
    data: ListTitlesType[];
  }>("/sherpa/v0/api/titles");
  return res.data;
}

interface UpdateCompanyProfilePayload {
  data: Partial<ClientDetailsInterface>;
  accountId: number;
}
export async function updateCompanyProfile({
  accountId,
  data,
}: UpdateCompanyProfilePayload) {
  const res = await axios({
    method: HttpMethods.PATCH,
    url: `${baseUrl.SHERPA}/accounts/${accountId}`,
    data,
  });
  return res.data;
}
